<template>
  <div style="width: 100%; height: 100%" class="m-0 p-0">
    <div
      id="labelWarrantCard"
      class="card pt-0 mb-2 mt-0"
      v-for="(lebel, index) in allData"
      :key="index"
      :class="useButtonForPrint ? '' : 'hide-in-print'"
    >
      <div class="vx-row" style="height: 0.7cm">
        <div class="vx-col w-1/3"></div>
        <div class="vx-col w-1/2 mx-0">
          <h3
            class="float-left mr-12"
            style="font-size: 1rem; font-weight: 900"
          >
            {{ dataFromParent.basketId ? dataFromParent.basketId : "--" }}
          </h3>
          <h3 class="float-right" style="font-size: 1rem; font-weight: 900">
            {{ allData[index].rowId }}
          </h3>
        </div>
        <div class="vx-row w-1/6 vx-col">
          <QRCanvas :options="options" />
        </div>
      </div>
      <div class="vx-row" dir="ltr" style="height: 0.7cm; font-weight: 900">
        <h3 class="pt-2 pl-6 pr-12">{{ allData[index].avasysName }}</h3>
      </div>
      <div
        class="vx-row"
        style="height: 0.5cm; padding-right: 30%; font-weight: 900"
      >
        <barcode
          :value="lebel.serial"
          :options="{ displayValue: false }"
        ></barcode>
      </div>
      <h4
        class="my-0"
        style="
          text-align: center;
          margin-right: 30%;
          letter-spacing: 1px;
          line-height: 1.3;
        "
      >
        {{ lebel.serial ? lebel.serial : "null" }}
      </h4>
      <div dir="ltr" class="px-12 m-0" style="width: 100%">
        <h3 class="mb-1">
          {{ allData[index].mainWarranty.startTimeOfMainWarranty }}
        </h3>
        <h3 class="m-0">
          {{ allData[index].mainWarranty.endTimeOfMainWarranty }}
        </h3>
      </div>
      <div class="vx-row float-right px-12 m-0" style="height: 15%">
        <h3
          v-for="(alternativeWarrantiesInfo, index) in allData[index]
            .alternativeWarrantiesInfo"
          :key="index"
        >
          {{ alternativeWarrantiesInfo.alternativeType }}:{{
            alternativeWarrantiesInfo.guarantyDuration
          }}
        </h3>
      </div>
    </div>
    <div class="vx-row">
      <div class="w-full vx-col">
        <vs-button
          type="button"
          class="float-right purple hide-in-print"
          @click="printWindow()"
          >{{ $t("Print") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import VueBarcode from "@xkeshi/vue-barcode";
import { QRCanvas } from "qrcanvas-vue";
import "@/assets/scss/vuesax-rtl/_labelWarrantCard.scss";
import store from "@/store/store";

export default {
  name: "warehouseManagement_DischargePermission_Index",
  data() {
    return {
      modelForApi: {
        inventoryTransactionId: 0,
        stockId: 0,
      },
      useButtonForPrint: false,
      allData: {},
      model: {},
      dataFromParent: this.$route.query,
      siteOrderNumber: "",
      labelInfo: [],
      currentTime: "",
      options: {
        cellSize: 8,
        data: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      recipientInfoDetails: "draftOrder/recipientInfoDetails",
    }),
  },
  mounted() {
    this.modelForApi = {
      transactionId: this.dataFromParent.transactionId,
      stockId: this.dataFromParent.stockId,
    };
    store.dispatch("loader/show");
    this.CheckOutPrint(this.modelForApi)
      .then((r) => {
        store.dispatch("loader/hide");
        this.allData = r;
        this.options.data = this.allData.qrCodeInfo;
      })
      .catch((err) => store.dispatch("loader/hide"));
  },
  methods: {
    ...mapActions({
      CheckOutPrint: "checkOutTransactions/CheckOutPrint",
      printCompeleteOneRow: "checkOutTransactions/printCompeleteOneRow",
    }),
    printWindow() {
      this.useButtonForPrint = true;
      setTimeout(() => {
        window.print();
        this.printCompeleteOneRow(this.modelForApi).then(() => {});
      }, 1000);
    },
  },
  components: {
    QRCanvas,
    VueBarcode,
  },
};
</script>
